import * as _ from "lodash";

import { ActionTypes } from './action-types';
import { IBillingState } from "./state";
import { IApSbsItem, IBilledCenterForList, IBillingDetail, ISearchForList } from '../../models';
import { INotBilled } from "./actions";

// reducer interfaces

interface ISetBilledByCenterList {
    type: string,
    list: IBilledCenterForList[]
}

interface ISetBilledToCenterList {
    type: string,
    list: IBilledCenterForList[]
}

interface ISetSearchList {
    type: string,
    list: ISearchForList[]
}

interface ISetBillingList {
    type: string,
    list: IBillingDetail[]
}

interface ISetNotBilledList {
    type: string,
    list: INotBilled[]
}

interface ISetApSbsReport {
    type: string,
    list: IApSbsItem[]
}

interface ISetDetail {
    type: string,
    details: IBillingDetail
}

interface IUpdateMedicareParticipating {
    type: string,
    medicareParticipating: number
}

// reducer functions

const setPendingList = (state: IBillingState, action: ISetBillingList) => {
    state.pending = action.list;
    return state;
}

const setBilledByCenterList = (state: IBillingState, action: ISetBilledByCenterList) => {
    state.billedByCenter = action.list;
    return state;
}

const setBilledToCenterList = (state: IBillingState, action: ISetBilledToCenterList) => {
    state.billedToCenter = action.list;
    return state;
}

const setNotBilledList = (state: IBillingState, action: ISetNotBilledList) => {
    state.notBilled = action.list;
    return state;
}

const setUpcomingList = (state: IBillingState, action: ISetBillingList) => {
    state.upcoming = action.list;
    return state;
}

const setSearchList = (state: IBillingState, action: ISetSearchList) => {
    state.search = action.list;
    return state;
}

const setDetails = (state: IBillingState, action: ISetDetail) => {
    state.details = action.details;
    return state;
}

const setApSbsReport = (state: IBillingState, action: ISetApSbsReport) => {
    state.apSbsReport = action.list;
    return state;
}

const updateMedicareParticipating = (state: IBillingState, action: IUpdateMedicareParticipating) => {
    state.details.billableNephrectomy.donor.center.physicianDonorNephrectomyCharges = action.medicareParticipating;
    return state;
}

// reducer creation

var initialState: IBillingState = {
    pending: [],
    billedByCenter: [],
    billedToCenter: [],
    notBilled: [],
    upcoming: [],
    search: [],
    details: null,
    apSbsReport: []
};

const createReducer = (initialState: IBillingState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = _.cloneDeep(state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_PENDING_LIST]: setPendingList,
    [ActionTypes.SET_BILLED_BY_LIST]: setBilledByCenterList,
    [ActionTypes.SET_BILLED_TO_LIST]: setBilledToCenterList,
    [ActionTypes.SET_NOT_BILLED_LIST]: setNotBilledList,
    [ActionTypes.SET_UPCOMING_LIST]: setUpcomingList,
    [ActionTypes.SET_SEARCH_LIST]: setSearchList,
    [ActionTypes.SET_DETAILS]: setDetails,
    [ActionTypes.UPDATE_MEDICARE_PARTICIPATING]: updateMedicareParticipating,
    [ActionTypes.SET_AP_SBS_REPORT]: setApSbsReport
}

export const Reducer = createReducer(initialState, handlers);
